import script from "./SelectDropDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectDropDown.vue?vue&type=script&setup=true&lang=ts"

import "./SelectDropDown.vue?vue&type=style&index=0&id=bc727f52&lang=scss&scoped=true"

import exportComponent from "/home/forge/usta.ge/vue-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc727f52"]])

export default __exports__